<script setup lang="ts">
import { CellState } from '../index'

withDefaults(
  defineProps<{
    label?: string | number
    state?: CellState
    today?: boolean
  }>(),
  {
    label: '',
    today: false,
    state: CellState.Default,
  },
)
</script>

<template lang="pug">
button.calendar-cell.typ-14-20-500.flex-center-center.h-32.w-100p(type="button" :class="{ [state]: state !== CellState.Default && state !== CellState.Disabled, today: today && state === CellState.Default }" :disabled="state === CellState.Disabled" :aria-pressed="state === CellState.Selected")
  slot {{ label }}
</template>

<style scoped src="../calendar.css"></style>
